import errorFace from 'assets/images/error-face.svg';

import React, { Fragment, useState } from 'react';

import { t, Trans } from '@lingui/macro';

import Footer from 'components/Footer';

import './SomethingWentWrong.styl';
import { Link, useNavigate } from 'react-router-dom';

const SomethingWentWrong = ({ resetError }) => {
  const [sendReport] = useState('notSent');

  return (
    <div className='something-wrong-wrapper'>
      <ToBeSent sendReport={sendReport} resetError={resetError} />

      <Footer classes='main' copyright={false} />
    </div>
  );
};

const ToBeSent = ({ resetError }) => {
  const navigate = useNavigate();
  return (
    <Fragment>
      <img src={errorFace} alt='something went wrong' />
      <div className='something-wrong'>
        <h1>{t({ id: 'something.wrong.initial.title', message: `Ooops` })}</h1>

        <h2>
          {t({
            id: 'something.wrong.initial.subtitle',
            message: `Something went wrong`,
          })}
        </h2>

        <p>
          {t({
            id: 'something.wrong.initial.paragraph.one',
            message: `Don't Panic!`,
          })}
        </p>

        <p>
          {t({
            id: 'something.wrong.initial.paragraph.two',
            message: `Our support team is here to help.`,
          })}
        </p>
        <Link
          component='button'
          underline='always'
          onClick={() => {
            window.history.length > 1
              ? navigate(-1)
              : window.location.reload(true);
            window.setTimeout(() => resetError(), 100);
          }}
          sx={{ textAlign: 'start' }}
        >
          <p>
            <Trans id='something.wrong.back'>
              Please click here to go back
            </Trans>
          </p>
        </Link>
      </div>
    </Fragment>
  );
};

export default SomethingWentWrong;
